import { render, staticRenderFns } from "./FormUiSlider.vue?vue&type=template&id=48e572f8"
import script from "./FormUiSlider.vue?vue&type=script&lang=js"
export * from "./FormUiSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports